import { SheetRect } from './findFreeSpot';

export type RollLengthBounds = { minMm: number; maxMm: number };

// Lengths are whole millimetres: the editor, the basket and the production file all
// carry the same integer, so a float from a drag never prices differently from what prints.
export function clampSheetLengthMm(lengthMm: number, bounds: RollLengthBounds): number {
  return Math.min(bounds.maxMm, Math.max(bounds.minMm, Math.ceil(lengthMm - 1e-6)));
}

// The sheet length needed to hold every artwork rect without cropping: the lowest
// artwork edge, never shorter than the minimum. May exceed the maximum — callers decide
// what to do with artwork that cannot fit.
export function getArtworkLengthMm(rects: SheetRect[]): number {
  return rects.reduce((bottom, rect) => Math.max(bottom, rect.yMm + rect.heightMm), 0);
}

export function isUsableRollLength(bounds: RollLengthBounds | undefined): bounds is RollLengthBounds {
  return (
    !!bounds &&
    Number.isFinite(bounds.minMm) &&
    Number.isFinite(bounds.maxMm) &&
    bounds.minMm > 0 &&
    bounds.maxMm >= bounds.minMm
  );
}
